/* eslint-disable @typescript-eslint/ban-ts-comment */
import PropTypes from 'prop-types';
import React from 'react';

import { useTranslation } from '../../../hooks';
import { InputProps } from './types';

export function FilterSelectDataExams({ config }: InputProps) {
  const { t } = useTranslation();
  return (
    // @ts-ignore
    React.createElement(config.component, {
      name: config.nameSelect,
      label: t(config.name),
      placeholder: `${t('Enter a')} ${t(config.name)}`,
      isModal: true,
      statusExam: config.status,
      bodyRequest: config.bodyRequest,
      type: config.nameSelect
    })
  );
}

FilterSelectDataExams.propTypes = {
  config: PropTypes.object
};

export default FilterSelectDataExams;
